import { render } from "./Clients.vue?vue&type=template&id=fe46d9c2"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=fe46d9c2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__